import React from 'react';
import PropTypes from 'prop-types';

import {Box, ListItem, ListItemText, Chip, Typography, Link, IconButton, Tooltip} from 'views/components';

import {CheckCircle as CheckCircleIcon} from 'views/icons';

import {Translate, translate} from 'views/module';

import Backend from 'utils/backend';

const SlipView = (props) => {
  const [status, setStatus] = React.useState('IN_PROGRESS');

  const item = props.item;
  const statusProgressWrap = props.statusProgressWrap;
  const weekOf = props.weekOf;

  const hours = item.hours;
  const confirmedHours = hours.confirmedHours;
  const totalHours = hours.totalHours;
  const confirmedCost = confirmedHours * 35;
  const totalCost = totalHours * 35;

  React.useEffect(() => {
    setStatus(item.status);
  }, [item]);

  const onComplete = () => {
    statusProgressWrap(async () => {
      try {
        setStatus('COMPLETE');
        await Backend.paymentSlip.markCaregiverSlipCompete(item.caregiverRn, weekOf);
      } catch (e) {
        setStatus('IN_PROGRESS');
        throw e;
      }
    }, {debugString: 'CAREGIVER_PAYMENT_SLIP_MARK_COMPLETE_DASHBORD'});
  };

  return (
    <ListItem
      divider
      secondaryAction={
        <Chip
          label={translate(`dashboardWidgets.CaregiverPaymentStatus.Progress.${status}`)}
          color={status === 'IN_PROGRESS' ? 'warning' : 'success'}
          variant="outlined"
          sx={{
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '8px', // Ensures spacing for icon
          }}
          onDelete={status === 'IN_PROGRESS' ? onComplete : undefined}
          deleteIcon={
            status === 'IN_PROGRESS' ? (
              <Tooltip title={translate(`dashboardWidgets.CaregiverPaymentStatus.MarkAsComplete`)}>
                <IconButton onClick={onComplete} size="small">
                  <CheckCircleIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : null
          }
        />
      }
    >
      <ListItemText
        primary={
          <Link
            href={`/caregiver/${item.caregiver.caregiverRn}`}
            sx={{textDecoration: 'none', color: '#1976d2', fontWeight: 500, fontSize: '1em'}}
          >
            {item.caregiver.name.trim()}
          </Link>
        }
        secondary={
          <Box sx={{display: 'grid'}}>
            <Typography variant="caption" color="text.secondary">
              <Translate
                expression='dashboardWidgets.CaregiverPaymentStatus.ConfirmedHours'
                substitute={{confirmedHours, confirmedCost}}
              />
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <Translate
                expression='dashboardWidgets.CaregiverPaymentStatus.TotalHours'
                substitute={{totalHours, totalCost}}
              />
            </Typography>
          </Box>
        }
        primaryTypographyProps={{variant: 'subtitle1'}}
        secondaryTypographyProps={{component: 'div'}}
      />
    </ListItem>
  );
};

SlipView.propTypes = {
  item: PropTypes.object.isRequired,
  weekOf: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(SlipView);
